<template>
  <div>
    <PageAllow controller="Shops" action="shopPsiDetail" />
    <Breadcrumbs :items="items" />
    <v-slide-x-transition>
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <SearcherDatetimeRangeWithRadio
                v-model="options"
                type="datetime"
                show-radios
                :radios="datetimeRadios"
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
              <!-- 出入库明细导出-->
              <v-btn
                v-if="
                  $permission.permissionAllow('Shops', 'shopPsiDetailExport')
                "
                small
                color="print"
                dark
                class="ms-1"
                @click="exportExcel()"
              >
                <v-icon x-small class="pe-1">fa-file-export</v-icon>
                {{ $t("ShopPsi.export") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>

        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <!-- 门店 -->
                <v-col cols="12" sm="6" md="4">
                  <SearchPsiShop v-model="shopSelected" unclearable />
                </v-col>
                <!-- 商品分类 -->
                <v-col cols="12" sm="6" md="4">
                  <SearchMaterialCategoriesWithDescendants
                    v-model="materialCategoriesSelected"
                    :shopId="shop_id"
                  />
                </v-col>
                <!-- 商品 -->
                <v-col cols="12" sm="6" md="4">
                  <SearchMaterial
                    v-model="materialSelected"
                    :material-categories="materialCategoriesSelected"
                    :shopId="shop_id"
                  />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="shop_stock_materials"
            :options.sync="options"
            :loading="loading"
            :page.sync="paging.page"
            :server-items-length="paging.count"
            multi-sort
            class="elevation-1 px-4 pt-1 sticky-table"
            id="sticky-table"
            :class="stickTableCols ? 'sticky-first-col sticky-last-col' : ''"
            fixed-header
            :footer-props="$t('$config.footer-props')"
          >
            <!-- 单价 -->
            <template v-slot:item.price="{ item }">
              {{ $t("Global.money") }}{{ item.price | formatMoney }}
            </template>
            <!-- 商品名称 -->
            <template v-slot:item.material_name="{ item }">
              <span class="text-no-wrap">
                {{
                  $t("Material.materialNameWithCode", [
                    item.material_code,
                    item.material_name,
                  ])
                }}
              </span>
            </template>
            <!-- 出入库类型 -->
            <template v-slot:item.order_flg="{ item }">
              <v-chip
                small
                label
                :color="item.order_flg | outInFlgsColor"
                :text-color="item.order_flg | outInFlgsTextColor"
              >
                {{ item.order_flg | outInFlgsText }}
              </v-chip>
            </template>
            <!-- 出入库数量 -->
            <template v-slot:item.order_num="{ item }">
              <span class="text-no-wrap">
                {{ $numberFormatter.formatTwoDot(item.order_num, true)
                }}{{ item.unit }}
              </span>
            </template>
            <!-- 实际出入库数量 -->
            <template v-slot:item.actual_num="{ item }">
              <span class="text-no-wrap">
                {{ $numberFormatter.formatTwoDot(item.actual_num, true)
                }}{{ item.unit }}
              </span>
            </template>
            <!-- 库存总价 -->
            <template v-slot:item.sub_total="{ item }">
              {{ $t("Global.money") }}{{ item.sub_total | formatMoney }}
            </template>
            <!-- 操作员 -->
            <template v-slot:item.operator>
              {{ shopSelected ? shopSelected.shop_user.name : "" }}
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
  </div>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import Shops from "@/api/shops";
import SearchPsiShop from "@/components/plugins/SearchPsiShop";
import SearchMaterial from "./plugins/SearchMaterial";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";
import SearchMaterialCategoriesWithDescendants from "./plugins/SearchMaterialCategoriesWithDescendants";

const defaultOptions = {
  datetimeRadioSelected: "created",
  created_time_from:
    new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  actual_time_from: "",
  actual_time_to: "",
  material_id: null,
  category_codes: [],
};
export default {
  components: {
    PageAllow,
    Breadcrumbs,
    SearchPsiShop,
    SearchMaterialCategoriesWithDescendants,
    SearchMaterial,
    SearcherDatetimeRangeWithRadio,
  },
  data: () => ({
    options: JSON.parse(JSON.stringify(defaultOptions)),
    shopSelected: null,
    shop_id: null,
    materialSelected: null,
    paging: [],
    loading: false,
    shop_stock_materials: [],
    materialCategoriesSelected: [],
  }),
  mounted() {
    this.$commonUtils.loadOptions("shopPsi", ["shopSelected"]).then(
      function (data) {
        if (data.options) {
          this.options = data.options;
        }
        //  else this.resetSearch();
        // this.shop_id = Number(this.$route.query.shop_id);
        // this.materialSelected = Number(this.$route.query.material_id);
        data.selecteds.forEach((selected) => {
          switch (selected.key) {
            case "shopSelected":
              this.shopSelected = selected.value;
              break;
          }
        });
      }.bind(this)
    );
  },
  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.shopPsi"),
        disabled: false,
        href: "/shop-psi",
      },
      {
        text: i18n.t("Nav.shopInOut"),
        disabled: true,
      },
    ],
    headers: () => [
      {
        text: i18n.t("ShopPsi.stockOrderAnalyze.stock_name"),
        align: "center",
        sortable: false,
        value: "stock_name",
      },
      {
        text: i18n.t("ShopPsi.stockOrderAnalyze.stock_order_code"),
        align: "center",
        sortable: false,
        value: "stock_order_code",
      },
      {
        text: i18n.t("ShopPsi.stockOrderAnalyze.material_name"),
        align: "center",
        sortable: false,
        value: "material_name",
      },
      {
        text: i18n.t("ShopPsi.stockOrderAnalyze.order_flg"),
        align: "center",
        sortable: false,
        value: "order_flg",
      },
      {
        text: i18n.t("ShopPsi.stockOrderAnalyze.price"),
        align: "center",
        sortable: false,
        value: "price",
      },
      {
        text: i18n.t("ShopPsi.stockOrderAnalyze.order_num"),
        align: "center",
        sortable: false,
        value: "order_num",
      },
      {
        text: i18n.t("ShopPsi.stockOrderAnalyze.actual_num"),
        align: "center",
        sortable: false,
        value: "actual_num",
      },
      {
        text: i18n.t("ShopPsi.stockOrderAnalyze.sub_total"),
        align: "center",
        sortable: false,
        value: "sub_total",
      },
      {
        text: i18n.t("ShopPsi.stockOrderAnalyze.operator"),
        align: "center",
        sortable: false,
        value: "operator",
      },
    ],
    datetimeRadios: () => [
      {
        key: "created",
        text: i18n.t("ShopPsi.created_time"),
      },
      {
        key: "actual",
        text: i18n.t("ShopPsi.actual_time"),
      },
    ],
    ...mapState(["settings", "stickTableCols"]),
  },
  methods: {
    onSearch() {
      this.options = Object.assign({}, this.options);
    },
    resetSearch() {
      this.materialSelected = null;
      this.shopSelected = null;
      this.materialCategoriesSelected = [];
      this.options = JSON.parse(JSON.stringify(defaultOptions));
    },
    getshopPsiDetailFromAPI() {
      this.loading = true;
      Shops.shopPsiDetail(
        Object.assign({}, this.options, { shop_id: this.shop_id })
      ).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.paging = response.data.paging;
            this.shop_stock_materials = response.data.in_out_detail;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
          this.loading = false;
        }.bind(this)
      );
    },
    exportExcel() {
      Shops.shopPsiDetailExports(
        Object.assign({}, this.options, { shop_id: this.shop_id })
      );
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        this.materialSelected = Number(this.$route.query.material_id);
      },
    },
    options: {
      deep: true,
      handler() {
        if (this.shop_id) {
          this.getshopPsiDetailFromAPI();
        }
      },
    },
    shopSelected: {
      immediate: true,
      handler() {
        if (this.shopSelected) {
          this.shop_id = this.shopSelected.id;
          // this.materialSelected = null;
          if (this.shopSelected) {
            this.getshopPsiDetailFromAPI();
          }
          sessionStorage.setItem(
            "shopPsi-shopSelected",
            JSON.stringify(this.shopSelected)
          );
        } else {
          this.shop_id = null;
          this.shop_stock_materials = [];
          this.materialCategoriesSelected = [];
          this.paging = [];
        }
      },
    },

    materialCategoriesSelected: {
      handler() {
        this.options.category_codes = this.materialCategoriesSelected
          ? this.materialCategoriesSelected.map((e) => {
              return e.code;
            })
          : [];
      },
    },

    materialSelected: {
      immediate: true,
      handler() {
        this.options.material_id = this.materialSelected
          ? this.materialSelected
          : null;
      },
    },
  },
};
</script>
